export const idlePopupDisplayController = {
  initial: 'controllerIdle',
  states: {
    controllerIdle: {
      on: {
        GAMING_USER_DETAILS_FETCHED: {
          target: 'updateCookiesData',
          cond: 'isInitialPermissionToDisplayIdlePopup',
        },
        SESSION_STATE_LOGGED_OUT: {
          target: 'hideIdlePopup',
          actions: ['changeIdlePopupStatusToDisabled'],
          cond: 'isIdlePopupOpened',
        },
        OPEN_GAME_MODAL: {
          target: 'hideIdlePopup',
          actions: ['changeIdlePopupStatusToDisabled'],
          cond: 'isIdlePopupOpened',
        },
        LAYOUT_CHANGE_END: [
          {
            target: 'hideIdlePopup',
            actions: [
              'changeIdlePopupStatusToDisabled',
              'hideIdlePopupSetCookie',
            ],
            cond: 'isIdlePopupOpened',
          },
          {
            target: 'updateCookiesData',
            actions: ['changeIdlePopupStatusToDisabled'],
            cond: 'isPermissionToDisplayIdlePopup',
          },
        ],
        VIEW_IDLE_POPUP_GAME_TILE_CLICK: {
          target: 'hideIdlePopup',
          actions: [
            'changeIdlePopupStatusToDisabled',
            'hideIdlePopupSetCookie',
            'trackIdlePopupGameTileClick',
          ],
        },
        VIEW_IDLE_POPUP_PLAY_NOW_CLICK: {
          target: 'hideIdlePopup',
          actions: [
            'changeIdlePopupStatusToDisabled',
            'hideIdlePopupSetCookie',
            'trackIdlePopupPlayBtnClick',
          ],
        },
        VIEW_IDLE_POPUP_CLOSE_BUTTON_CLICK: {
          target: 'hideIdlePopup',
          actions: [
            'changeIdlePopupStatusToDisabled',
            'hideIdlePopupSetCookie',
          ],
        },
        VIEW_IDLE_POPUP_CHECKBOX_CLICK: {
          actions: ['udpateIdlePopoupLongPauseCookie'],
        },
      },
    },
    updateCookiesData: {
      invoke: {
        src: 'updateIdlePopupCookie',
        onDone: {
          actions: ['updateIdlePopupCookie'],
          target: 'startTimerIdlePopup',
        },
      },
    },
    startTimerIdlePopup: {
      initial: 'waitingForRenderIdlePopup',
      states: {
        waitingForRenderIdlePopup: {
          after: {
            IDLE_POPUP_SHORT_DELAY: [
              {
                target: '#root.main.idlePopupDisplayController.renderIdlePopup',
                actions: ['updateIdlePopupGame'],
                cond: 'isPermissionToRenderIdlePopup',
              },
              {
                target: '#root.main.idlePopupDisplayController.controllerIdle',
              },
            ],
          },
          on: {
            VIEW_IDLE_POPUP_CLOSE_BUTTON_CLICK: {
              target: 'stop',
            },
            OPEN_GAME_MODAL: {
              target: 'stop',
            },
            LAYOUT_PAGEID_CHANGE: {
              target: 'stop',
              cond: 'isRouteBlockedForIdlePopup',
            },
          },
        },
        stop: {
          always: '#root.main.idlePopupDisplayController.controllerIdle',
        },
      },
    },
    renderIdlePopup: {
      invoke: {
        src: 'prepareIdlePopupContent',
        onDone: {
          actions: [
            {
              type: 'batchLayoutOperations',
              data: '$event.data.updates',
              meta: {
                selectors: ['$action.data'],
              },
            },
            'changeIdlePopupStatusToEnabeld',
          ],
          target: 'hideFloatingIconComponent',
        },
      },
    },
    hideFloatingIconComponent: {
      invoke: {
        src: 'updateFloatingIconContent',
        onDone: {
          actions: [
            {
              type: 'batchLayoutOperations',
              data: '$event.data.updates',
              meta: {
                selectors: ['$action.data'],
              },
            },
          ],
          target: 'showIdlePopoupComponent',
        },
      },
    },
    showIdlePopoupComponent: {
      entry: [
        {
          type: 'showLayoutComponent',
          data: '$context.idlePopupComponent.id',
          meta: {
            selectors: ['$action.data'],
          },
        },
        'trackIdlePopupComponent',
      ],
      always: 'controllerIdle',
    },
    hideIdlePopup: {
      invoke: {
        src: 'updateFloatingIconContent',
        onDone: {
          actions: [
            {
              type: 'batchLayoutOperations',
              data: '$event.data.updates',
              meta: {
                selectors: ['$action.data'],
              },
            },
          ],
          target: 'hideIdlePopupComponent',
        },
      },
    },
    hideIdlePopupComponent: {
      entry: [
        {
          type: 'hideLayoutComponent',
          data: '$context.idlePopupComponent.id',
          meta: {
            selectors: ['$action.data'],
          },
        },
        'trackIdlePopupHideForSevenDays',
      ],
      always: 'controllerIdle',
    },
  },
};
